import moment from "moment";

export const GRID_SPACING = 3;
export const DRAWER_WIDTH = 260;
export const APP_DRAWER_WIDTH = 320;

export const formateDate = (date: any) => {
  return moment(date).format("DD/MM/YYYY hh:mm A");
};

export const removeEmptyValues = (data: any) => {
  for (var propName in data) {
    if (!data[propName] || data[propName].length === 0) {
      delete data[propName];
    } else if (typeof data[propName] === "object") {
      removeEmptyValues(data[propName]);
    }
  }
  return data;
};

export const createQueryParams = (params: any) => {
  const newObj: any = {};
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      newObj[key] = value;
    }
  }
  return Object.entries(newObj)
    .map((e) => e.join("="))
    .join("&");
};
